var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 2.057 1 1.586 1.293 1.293C1.586 1 2.057 1 3 1C3.943 1 4.414 1 4.707 1.293C5 1.586 5 2.057 5 3V9C5 9.943 5 10.414 4.707 10.707C4.414 11 3.943 11 3 11C2.057 11 1.586 11 1.293 10.707C1 10.414 1 9.943 1 9V3ZM7 3C7 2.057 7 1.586 7.293 1.293C7.586 1 8.057 1 9 1C9.943 1 10.414 1 10.707 1.293C11 1.586 11 2.057 11 3V9C11 9.943 11 10.414 10.707 10.707C10.414 11 9.943 11 9 11C8.057 11 7.586 11 7.293 10.707C7 10.414 7 9.943 7 9V3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.481d331af4eabd5b15c8f82e27c36df2.svg";
export { ForwardRef as ReactComponent };